import { useState } from "react";
import RentalNote from "./RentalNote";
import { useToast } from "app/hooks";
import { RentalOrBuy } from "./RentalOrBuy";
import { GLOBALS } from "config";
import { logError } from "@lib/logger";
import { CoinIcon, FreeTicketIcon } from "./Icons";
import { ResponseError } from "@api/runtime";
import { RentalRequestModel } from "@api/models";
import { deleteCampaignPaymentCookie } from "@lib/analyticLog";

const SingleEpisodeRental = ({
  episodeId,
  episodeIndexId,
  seriesIndexId,
  episodePrice,
  closeFunction,
  disableBonus,
  userBonusTicket,
}: {
  episodeId: string;
  episodeIndexId: number | undefined;
  seriesIndexId: number | undefined;
  episodePrice: number;
  userBonusTicket: number;
  disableBonus?: boolean;
  closeFunction: () => void;
}) => {
  const { pushToast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const handleClickRental = async () => {
    setIsLoading(true);
    await fetch("/api/checkout/rental", {
      method: "POST",
      body: JSON.stringify({
        articleIds: [episodeId],
        amount: useTicket ? 0 : episodePrice,
        ticketCount: useTicket ? 1 : 0,
      } as RentalRequestModel),
    })
      .then((res) => {
        if (res.status === 200) {
          pushToast(`エピソードを${GLOBALS.IS_RENTAL ? "レンタル" : "購入"}しました。`);
          deleteCampaignPaymentCookie("article", episodeIndexId);
          deleteCampaignPaymentCookie("series", seriesIndexId);
          setTimeout(() => {
            closeFunction();
            window.location.reload();
          }, 1000);
          return;
        } else {
          throw new ResponseError(res);
        }
      })
      .catch(() => {
        setIsLoading(false);
        logError("server error: single episode checkout");
        pushToast("エラーが発生しました。時間をおいて再度お試しください。", {
          type: "error",
        });
        closeFunction();
      });
  };
  const useTicket: boolean = !disableBonus && userBonusTicket > 0;
  return (
    <div className="dialog-content">
      <div className="dialog-h">
        <span className="dialog-h-price">
          {useTicket && (
            <>
              <FreeTicketIcon size={18} className="dialog-h-price-icon" />
              1枚
            </>
          )}
          {!useTicket && (
            <>
              <CoinIcon size={18} className="dialog-h-price-icon" />
              {episodePrice}
            </>
          )}
        </span>
        で<RentalOrBuy />
        しますか？
      </div>
      {GLOBALS.IS_RENTAL && (
        <div className="dialog-term">
          レンタル期間：
          <span className="dialog-term-term">{GLOBALS.RENTAL_PERIOD}</span>
        </div>
      )}
      <div className="dialog-btns">
        <button
          type="button"
          className={"dialog-btn mode-buy" + (isLoading ? " mode-loading" : "")}
          onClick={() => handleClickRental()}
        >
          <RentalOrBuy />
          する
        </button>
        <button
          type="button"
          onClick={() => closeFunction()}
          className={"dialog-btn mode-moderate" + (isLoading ? " mode-loading" : "")}
        >
          キャンセル
        </button>
      </div>
      <RentalNote />
    </div>
  );
};

export default SingleEpisodeRental;
